import TenantSwitch from '../plugins/ui-share-rbac/src/widgets/TenantSwitch/TenantSwitch';
import { IExtension, dynamicImport } from 'slipstream-components';
const extentions: IExtension = {
  "navActivities": [
    {
      "id": "open_intro",
      "index": 99,
      "position": "right",
      "component": dynamicImport(() => import(/* webpackChunkName: 'Intro' */ '../plugins/ui-common/src/widgets/Intro/Intro')),
      "capabilities": [
        "platform:pc",
        "feature:showIntro"
      ],
      "seperator": true
    },
    {
      "id": "job_monitor",
      "index": 120,
      "position": "right",
      "component": dynamicImport(() => import(/* webpackChunkName: 'JobMonitor' */ '../plugins/ui-common/src/widgets/JobMonitor/JobMonitor')),
      "capabilities": [
        "platform:pc"
      ],
      "seperator": true
    },
    {
      "id": "feedback",
      "index": 70,
      "position": "right",
      "component": dynamicImport(() => import(/* webpackChunkName: 'Feedback' */ 'slipstream-components'), 'Feedback', false),
      "capabilities": [
        "platform:pc"
      ]
    },
    {
      "id": "user",
      "index": 60,
      "position": "right",
      "component": dynamicImport(() => import(/* webpackChunkName: 'UserInfo' */ '../plugins/ui-common/src/widgets/UserInfo/UserInfo'))
    },
    {
      "id": "setting",
      "index": 40,
      "position": "leftbottom",
      "component": dynamicImport(() => import(/* webpackChunkName: 'SettingDrawer' */ 'slipstream-components'), 'SettingDrawer', false),
      "capabilities": [
        "platform:pc"
      ]
    },
    {
      "id": "fullscreen",
      "index": 20,
      "position": "right",
      "component": dynamicImport(() => import(/* webpackChunkName: 'Fullscreen' */ 'slipstream-components'), 'Fullscreen', false),
      "capabilities": [
        "platform:pc"
      ]
    },
    {
      "id": "help",
      "index": 0,
      "position": "right",
      "component": dynamicImport(() => import(/* webpackChunkName: 'GlobalHelpWrapper' */ '../plugins/ui-common/src/widgets/GlobalHelpWrapper/GlobalHelpWrapper')),
      "capabilities": [
        "platform:pc"
      ]
    },
    {
      "id": "alarm_monitor",
      "index": 75,
      "position": "right",
      "component": dynamicImport(() => import(/* webpackChunkName: 'AlarmMonitor' */ '../plugins/ui-monitor/src/widgets/AlarmMonitor/AlarmMonitor')),
      "capabilities": [
        "platform:pc"
      ]
    },
    {
      "id": "switch_tenant",
      "index": 100,
      "position": "right",
      "component": TenantSwitch,
      "seperator": true
    }
  ],
  "shellPlugins": [
    {
      "id": "job_status",
      "component": dynamicImport(() => import(/* webpackChunkName: 'GlobalJob' */ '../plugins/ui-common/src/widgets/GlobalJob/GlobalJob'), null, false)
    },
    {
      "id": "welcome",
      "component": dynamicImport(() => import(/* webpackChunkName: 'Welcome' */ '../plugins/ui-common/src/widgets/Welcome/Welcome'), null, false)
    },
    {
      "id": "maintenance",
      "component": dynamicImport(() => import(/* webpackChunkName: 'Maintenance' */ '../plugins/ui-common/src/widgets/Maintenance/Maintenance'), null, false)
    },
    {
      "id": "activity_check",
      "component": dynamicImport(() => import(/* webpackChunkName: 'RenewToken' */ '../plugins/ui-share-rbac/src/widgets/RenewToken/RenewToken'), null, false)
    }
  ],
  "dashlets": [
    {
      "id": "device_count_by_platform",
      "title": "Device Count By Platform",
      "thumbnail": "/static/ui-resource/images/thumb_sites_total_alerts.svg",
      "category": "category_devices",
      "component": dynamicImport(() => import(/* webpackChunkName: 'DeviceCountByPlatform' */ '../plugins/ui-resource/src/widgets/dashlets/DeviceCountByPlatform')),
      "capabilities": [
        "Devices:R",
        "TenantDevices:R"
      ]
    },
    {
      "id": "device_count_by_os",
      "title": "Device Count By OS",
      "thumbnail": "/static/ui-resource/images/thumb_sites_total_alerts.svg",
      "category": "category_devices",
      "component": dynamicImport(() => import(/* webpackChunkName: 'DeviceCountByOS' */ '../plugins/ui-resource/src/widgets/dashlets/DeviceCountByOS')),
      "capabilities": [
        "Devices:R",
        "TenantDevices:R"
      ]
    },
    {
      "id": "device_count_by_status",
      "title": "Device Count By Status",
      "thumbnail": "/static/ui-resource/images/thumb_sites_total_alerts.svg",
      "category": "category_devices",
      "component": dynamicImport(() => import(/* webpackChunkName: 'DeviceCountByStatus' */ '../plugins/ui-resource/src/widgets/dashlets/DeviceCountByStatus')),
      "capabilities": [
        "Devices:R",
        "TenantDevices:R"
      ]
    },
    {
      "id": "pop_top_alert1",
      "title": "Top 5 POPs with Alerts",
      "thumbnail": "/static/ui-resource/images/thumb_pops_top_alerts.svg",
      "description": null,
      "category": "category_pops",
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopPopsWithAlerts' */ '../plugins/ui-resource/src/widgets/dashlets/TopPopsWithAlerts')),
      "capabilities": [
        "PoPs:R"
      ]
    },
    {
      "id": "tenant_top_alert",
      "title": "Top 5 Tenants with Alarms",
      "thumbnail": "/static/ui-resource/images/thumb_pops_top_alerts.svg",
      "description": null,
      "category": "category_tenants",
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopTenantsWithAlerts' */ '../plugins/ui-resource/src/widgets/dashlets/TopTenantsWithAlerts')),
      "capabilities": [
        "Tenants:R"
      ]
    },
    {
      "id": "site_top_alerts",
      "title": "Top 5 Sites with Alarms",
      "thumbnail": "/static/ui-resource/images/thumb_sites_top_alerts.svg",
      "description": null,
      "category": "category_sites",
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopSitesWithAlerts' */ '../plugins/ui-resource/src/widgets/dashlets/TopSitesWithAlerts')),
      "capabilities": [
        "Alarms:R"
      ]
    },
    {
      "id": "site_total_alerts",
      "title": "Tenant Sites: Total Alarms",
      "thumbnail": "/static/ui-resource/images/thumb_sites_total_alerts.svg",
      "description": null,
      "category": "category_sites",
      "component": dynamicImport(() => import(/* webpackChunkName: 'SiteTotalAlert' */ '../plugins/ui-resource/src/widgets/dashlets/SiteTotalAlert')),
      "capabilities": [
        "Site Management:R",
        "Alarms:R"
      ]
    },
    {
      "id": "top_profiles_switching_links",
      "title": "Top Profiles Swiching Links",
      "thumbnail": "/static/ui-resource/images/thumb_sites_total_alerts.svg",
      "description": null,
      "category": "category_applications",
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopProfilesSwitchingLinks' */ '../plugins/ui-resource/src/widgets/dashlets/TopProfilesSwitchingLinks')),
      "capabilities": [
        "Link Switch Events:R"
      ]
    },
    {
      "id": "top_profiles_not_meeting_sla",
      "title": "Top Profiles not Meeting SLA",
      "thumbnail": "/static/ui-resource/images/thumb_sites_total_alerts.svg",
      "description": null,
      "category": "category_applications",
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopProfilesNotMeetingSLA' */ '../plugins/ui-resource/src/widgets/dashlets/TopProfilesNotMeetingSLA')),
      "capabilities": [
        "Link Switch Events:R",
        "feature:sdwan_adv"
      ]
    },
    {
      "id": "top_sites_switching_links",
      "title": "Top Sites Switching Links",
      "thumbnail": "/static/ui-resource/images/thumb_sites_total_alerts.svg",
      "description": null,
      "category": "category_sites",
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopSitesSwitchingLinks' */ '../plugins/ui-resource/src/widgets/dashlets/TopSitesSwitchingLinks')),
      "capabilities": [
        "Link Switch Events:R",
        "platform:pc",
        "feature:sdwan_adv"
      ]
    },
    {
      "id": "top_sites_not_meeting_sla",
      "title": "Top Sites not meeting SLA",
      "thumbnail": "/static/ui-resource/images/thumb_sites_total_alerts.svg",
      "description": null,
      "category": "category_sites",
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopSitesNotMeetingSLA' */ '../plugins/ui-resource/src/widgets/dashlets/TopSitesNotMeetingSLA')),
      "capabilities": [
        "Link Switch Events:R",
        "platform:pc",
        "feature:sdwan_adv"
      ]
    },
    {
      "id": "top_applications_by_volume",
      "title": "Applications: Top by Volume",
      "thumbnail": "/static/ui-resource/images/icon_image11.svg",
      "description": null,
      "category": "category_applications",
      "colSpan": 1,
      "editAction": true,
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopApplicationsByVolume' */ '../plugins/ui-resource/src/widgets/dashlets/TopApplicationsByVolume')),
      "capabilities": [
        "Application Visibility:R"
      ]
    },
    {
      "id": "top_applications_by_throughput",
      "title": "Applications: Top by Throughput",
      "thumbnail": "/static/ui-resource/images/thumb_sites_top_alerts.svg",
      "description": null,
      "colSpan": 2,
      "category": "category_applications",
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopApplicationsByThroughput' */ '../plugins/ui-resource/src/widgets/dashlets/TopApplicationsByThroughput')),
      "capabilities": [
        "Application SLA Performance:R"
      ]
    },
    {
      "id": "top_users_by_session",
      "title": "IP: Top Users by Session",
      "thumbnail": "/static/ui-resource/images/icon_image5.svg",
      "description": null,
      "editAction": true,
      "category": "category_security",
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopUsersBySession' */ '../plugins/ui-resource/src/widgets/dashlets/TopUsersBySession')),
      "capabilities": [
        "All Events:R"
      ]
    },
    {
      "id": "top_application_by_session",
      "title": "Applications: Top by Sessions",
      "thumbnail": "/static/ui-resource/images/icon_image7.svg",
      "description": null,
      "editAction": true,
      "colSpan": 1,
      "category": "category_applications",
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopApplicationBySessions' */ '../plugins/ui-resource/src/widgets/dashlets/TopApplicationBySessions')),
      "capabilities": [
        "All Events:R"
      ]
    },
    {
      "id": "top_virus_blocked",
      "title": "Virus: Top Blocked",
      "thumbnail": "/static/ui-resource/images/icon_image9.svg",
      "description": null,
      "editAction": true,
      "category": "category_security",
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopVirusBlocked' */ '../plugins/ui-resource/src/widgets/dashlets/TopVirusBlocked')),
      "capabilities": [
        "All Events:R"
      ]
    },
    {
      "id": "top_websites_blocked",
      "title": "Websites: Top Blocked",
      "thumbnail": "/static/ui-resource/images/icon_image7.svg",
      "description": null,
      "editAction": true,
      "category": "category_security",
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopWebsitesBlocked' */ '../plugins/ui-resource/src/widgets/dashlets/TopWebsitesBlocked')),
      "capabilities": [
        "All Events:R"
      ]
    },
    {
      "id": "top_spams_by_source",
      "title": "IP: Top Spams by Source",
      "thumbnail": "/static/ui-resource/images/icon_image7.svg",
      "description": null,
      "editAction": true,
      "category": "category_security",
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopSpamsBySource' */ '../plugins/ui-resource/src/widgets/dashlets/TopSpamsBySource')),
      "capabilities": [
        "All Events:R",
        "Antispam:R"
      ]
    },
    {
      "id": "top_sources_by_volume",
      "title": "Top Sources by Volume",
      "thumbnail": "/static/ui-resource/images/icon_image5.svg",
      "description": null,
      "editAction": true,
      "category": "category_security",
      "component": dynamicImport(() => import(/* webpackChunkName: 'TopSourcesByVolume' */ '../plugins/ui-resource/src/widgets/dashlets/TopSourcesByVolume')),
      "capabilities": [
        "All Events:R"
      ]
    },
    {
      "id": "firewall_top_denials",
      "title": "Firewall: Top Denials",
      "thumbnail": "/static/ui-resource/images/icon_image10.svg",
      "description": null,
      "editAction": true,
      "colSpan": 2,
      "category": "category_security",
      "component": dynamicImport(() => import(/* webpackChunkName: 'FirewallTopDenials' */ '../plugins/ui-resource/src/widgets/dashlets/FirewallTopDenials')),
      "capabilities": [
        "All Events:R",
        "Firewall:R"
      ]
    },
    {
      "id": "firewall_top_events",
      "title": "Firewall: Top Events",
      "thumbnail": "/static/ui-resource/images/icon_image7.svg",
      "description": null,
      "editAction": true,
      "category": "category_security",
      "component": dynamicImport(() => import(/* webpackChunkName: 'FirewallTopEvents' */ '../plugins/ui-resource/src/widgets/dashlets/FirewallTopEvents')),
      "capabilities": [
        "All Events:R",
        "Firewall:R"
      ]
    },
    {
      "id": "ips_top_events",
      "title": "IPS: Top Events",
      "thumbnail": "/static/ui-resource/images/icon_image9.svg",
      "description": null,
      "editAction": true,
      "category": "category_security",
      "component": dynamicImport(() => import(/* webpackChunkName: 'IPSTopEvents' */ '../plugins/ui-resource/src/widgets/dashlets/IPSTopEvents')),
      "capabilities": [
        "All Events:R",
        "IPS:R"
      ]
    },
    {
      "id": "ip_top_destination",
      "title": "IP: Top Destinations",
      "thumbnail": "/static/ui-resource/images/icon_image9.svg",
      "description": null,
      "editAction": true,
      "category": "category_security",
      "component": dynamicImport(() => import(/* webpackChunkName: 'IPTopDestinations' */ '../plugins/ui-resource/src/widgets/dashlets/IPTopDestinations')),
      "capabilities": [
        "All Events:R"
      ]
    },
    {
      "id": "ip_top_source",
      "title": "IP: Top Sources",
      "thumbnail": "/static/ui-resource/images/icon_image9.svg",
      "description": null,
      "editAction": true,
      "category": "category_security",
      "component": dynamicImport(() => import(/* webpackChunkName: 'IPTopSources' */ '../plugins/ui-resource/src/widgets/dashlets/IPTopSources')),
      "capabilities": [
        "All Events:R"
      ]
    },
    {
      "id": "topDestinationNatRulesHit",
      "title": "NAT: Destination Translation Hits",
      "thumbnail": "/static/ui-resource/images/icon_image7.svg",
      "description": null,
      "editAction": true,
      "colSpan": 1,
      "category": "category_security",
      "component": dynamicImport(() => import(/* webpackChunkName: 'NATDestinationHits' */ '../plugins/ui-resource/src/widgets/dashlets/NATDestinationHits')),
      "capabilities": [
        "All Events:R"
      ]
    },
    {
      "id": "topSourceNatRulesHit",
      "title": "NAT: Source Translation Hits",
      "thumbnail": "/static/ui-resource/images/icon_image7.svg",
      "description": null,
      "editAction": true,
      "colSpan": 1,
      "category": "category_security",
      "component": dynamicImport(() => import(/* webpackChunkName: 'NATSourceHits' */ '../plugins/ui-resource/src/widgets/dashlets/NATSourceHits')),
      "capabilities": [
        "All Events:R"
      ]
    },
    {
      "id": "threat_map_ips",
      "title": "Threat Map: IPS",
      "thumbnail": "/static/ui-resource/images/icon_image8.svg",
      "description": null,
      "rowSpan": 2,
      "colSpan": 2,
      "editAction": true,
      "category": "category_security",
      "component": dynamicImport(() => import(/* webpackChunkName: 'ThreatMapIPSDashlet' */ '../plugins/ui-resource/src/widgets/dashlets/ThreatMapIPSDashlet')),
      "capabilities": [
        "All Events:R",
        "IPS:R"
      ]
    },
    {
      "id": "threat_map_virus",
      "title": "Threat Map: Virus",
      "thumbnail": "/static/ui-resource/images/icon_image8.svg",
      "description": null,
      "editAction": true,
      "rowSpan": 2,
      "colSpan": 2,
      "category": "category_security",
      "component": dynamicImport(() => import(/* webpackChunkName: 'ThreatMapVirusDashlet' */ '../plugins/ui-resource/src/widgets/dashlets/ThreatMapVirusDashlet')),
      "capabilities": [
        "All Events:R",
        "Antivirus:R"
      ]
    }
  ]
}
export default extentions;